import { useState, useEffect } from "react";
import Loader from "components/Loader";
import MobileSupportTabBar from "components/TabBars/MobileSupportTabBar";
import { get_seo_title_for_single_keyword } from "services/buddyXApiHubService";
import HelpCard from "components/Cards/HelpCard";
import { Button, Col, Form } from "react-bootstrap";
import ArticleHeadlinesKeywordTable from "components/Tables/ArticleHeadlinesKeywordTable";
import Validator from "utils/Validator";
import classNames from "classnames";
import { css } from "aphrodite";
import pageStyles from "styles/pageStyles";
import InsufficientCreditsPopup from "components/InsufficientCreditsPopup";
import ToastAlert from "components/Alert/ToastAlert";
import { getInputFieldStyle, getButtonStyle } from "utils/formStyles";

export default function Page() {
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isResultGot, setIsResultGot] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [formData, setFormData] = useState({
    keywords: [],
  });
  const [showSearchItem, setShowSearchItem] = useState("");
  const [insufficientCreditsData, setInsufficientCreditsData] = useState(null);
  const [showInsufficientCredits, setShowInsufficientCredits] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [errors, setErrors] = useState({ keyword: "" });
  const [tabs, setTabs] = useState([]);
  const firstLevelTopic = "SEO";
  const secoundLevelTopic = "Title";
  const thirdLevelTopic = "Single Keyword";

  const handleInsufficientCredits = (balanceData) => {
    
    setInsufficientCreditsData(balanceData);
    setShowInsufficientCredits(true);
  };

  const closeInsufficientCredits = () => {
    setShowInsufficientCredits(false);
    setInsufficientCreditsData(null);
  };

  const handleKeywordChange = (e) => {
    setKeyword(e.target.value);
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    let error = "";
    if (
      name === "keyword" &&
      !Validator.validateRequired(keyword, Validator.validateSingleKeyword)
    ) {
      error = "Please enter keywords";
    }
    console.log(error);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleReset = () => {
    setShowSearchItem("");
    setIsResultGot(false);
    setKeyword("");
    setShowErrorNotification(false);
    setErrorMessage("");
    setErrors({ keyword: "" });
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const result = await get_seo_title_for_single_keyword(formData, handleInsufficientCredits);
      setShowSearchItem(formData.keywords[0]);
      setTabs(
        Object.keys(result).map((key, index) => ({
          label: `Draft ${String.fromCharCode(65 + index)}`,
          element: (
            <ArticleHeadlinesKeywordTable
              data={result[key]}
              topic={thirdLevelTopic}
            />
          ),
        }))
      );
      setIsResultGot(true);
    } catch (error) {
      console.error("Submission error:", error);
      setErrorMessage(error.message || "Failed to generate SEO titles. Please try again.");
      setShowErrorNotification(true);
      setIsResultGot(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    let isValid = Validator.validateRequired(
      keyword,
      Validator.validateSingleKeyword
    );
    if (isValid) {
      setFormData({
        keywords: [keyword],
      });
    }
    setIsFormValid(isValid);
  }, [keyword]);

  return (
    <div className={classNames("container-fluid", css(pageStyles.container))}>
      {/* Toast Notifications */}
      <ToastAlert
        show={showErrorNotification}
        message={errorMessage}
        type="error"
        icon="fas fa-exclamation-circle"
        duration={5000}
        onClose={() => setShowErrorNotification(false)}
        position="top-right"
      />
      <h1 className=" d-flex fw-normal justify-content-start align-items-center fw-bold">
        {secoundLevelTopic}
      </h1>
      <p className="fw-normal justify-content-start align-items-center">
        {firstLevelTopic} / {secoundLevelTopic} / <b>{thirdLevelTopic}</b>
      </p>
      <p className="fw-normal justify-content-start align-items-center">
        Find the most compelling <b> article headlines </b>
        tailored to your content, ensuring maximum click-through rates and
        engagement. Generate eye-catching titles that resonate with your
        audience and drive traffic to your site.
      </p>
      <div className="row">
        <div className="col-lg-9 col-md-10 col-sm-10">
          <HelpCard
            topic={"How To Use"}
            description={`${'"'}Article Headlines ${'"'} helps you craft compelling, optimised titles for your articles, boosting engagement and driving more traffic by improving click-through rates and search visibility.`}
            image={"/icon/pin.svg"}
          />
        </div>
      </div>
      <div className="p-2 mb-2 rounded">
        <div className="d-flex fw-bold mb-0">
          Find Your Headlines
        </div>
        <div className="row mb-2 align-items-end">
          <div className="mb-2">
            <p className="fw-normal justify-content-start align-items-center">
              Enter a keyword to get title suggestions.
            </p>
            <Form.Group>
              <div className="d-flex mt-2">
                <Col sm={6} className="me-2">
                  <Form.Control
                    type="text"
                    name="keyword"
                    placeholder="Enter keyword"
                    value={keyword}
                    onChange={handleKeywordChange}
                    isInvalid={!!errors.keyword}
                    onBlur={handleBlur}
                    required
                    className="px-2"
                    style={getInputFieldStyle('type2')}
                  />
                </Col>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-2 me-1">
                  <div className="d-flex justify-content-start align-items-end">
                    <Button
                      variant="dark"
                      className="me-1"
                      onClick={handleSubmit}
                      disabled={!isFormValid || isLoading}
                      style={getButtonStyle('type2', 'primary')}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" />
                          Generating...
                        </>
                      ) : (
                        "Search"
                      )}
                    </Button>
                    <Button
                      variant="outline-dark"
                      className="me-1"
                      onClick={handleReset}
                      style={getButtonStyle('type2', 'outline')}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </div>

      <div className="p-2">
        {showSearchItem !== "" && (
          <div>
            <p className="d-flex fw-bold mb-0">
              Title suggestions for
              <span className="search-item">&nbsp;"{showSearchItem}"</span>
            </p>
          </div>
        )}
        {isLoading && <Loader />}
        {isResultGot && <MobileSupportTabBar tabs={tabs} />}
      </div>
      {/* Insufficient Credits Popup */}
      <InsufficientCreditsPopup
        isOpen={showInsufficientCredits}
        onClose={closeInsufficientCredits}
        currentBalance={insufficientCreditsData?.currentBalance}
        requiredCredits={insufficientCreditsData?.requiredCredits}
        shortfall={insufficientCreditsData?.shortfall}
        actionName={insufficientCreditsData?.actionName}
      />
    </div>
  );
}
